// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import LawEnforcementDetails from '@deere/cps-it.warranty-model-factory/lib/law-enforcement-details';
import {buildDate} from '../../../../shared/services/build-date';

const LawEnforcementInfo = props =>
    <div className='law-enforcement-info'>
        <h4>
            <FormattedMessage id='LAW_ENFORCEMENT_AGENCY_DETAILS'/>
        </h4>
        <div className='row'>
            <LabeledString
                className='name'
                data={props.lawEnforcementInfo.agency.name}
                label='NAME'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='city'
                data={`${props.lawEnforcementInfo.agency.city}, ${props.lawEnforcementInfo.agency.state.value}`}
                label='CITY'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='country'
                data={props.lawEnforcementInfo.agency.country.value}
                label='COUNTRY'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='stolen-date'
                data={buildDate(props.lawEnforcementInfo.stolenDate)}
                label='STOLEN_DATE'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='report-number'
                data={props.lawEnforcementInfo.reportNumber}
                label='REPORT_NUMBER'
            />
        </div>
    </div>;

LawEnforcementInfo.displayName = 'LawEnforcementInfo';
LawEnforcementInfo.propTypes = {
    lawEnforcementInfo: PropTypes.instanceOf(LawEnforcementDetails).isRequired
};

export default LawEnforcementInfo;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/machine-status-updates/law-enforcement-info.js